
// VUU Official - PDP Gallery Enhancements: Keyboard Arrows, Touch Swipe, Thumbnail Clicks
(function() {
  function initGalleryEnhancements() {
    // 1. Keyboard Arrow Navigation
    if (!window._vuuArrowListenerAttached) {
      window.addEventListener('keydown', function(e) {
        if (['input', 'textarea', 'select'].includes(document.activeElement?.tagName?.toLowerCase())) return;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          var swiperEl = document.querySelector('media-gallery swiper-component');
          var swiper = swiperEl?.initSwiper || document.querySelector('.swiper-main')?.swiper;
          if (swiper) {
            e.preventDefault();
            if (e.key === 'ArrowLeft') swiper.slidePrev();
            if (e.key === 'ArrowRight') swiper.slideNext();
          }
        }
      });
      window._vuuArrowListenerAttached = true;
    }

    // 2. Direct Thumbnail Click Handling via Event Delegation
    if (!window._vuuThumbListenerAttached) {
      document.addEventListener('click', function(e) {
        var thumb = e.target.closest('.swiper-controls__thumbnail, .swiper-controls__thumbnails .swiper-slide, [data-zoom-target], .dialog-thumbnails-list__thumbnail');
        if (!thumb) return;
        
        var swiperEl = document.querySelector('media-gallery swiper-component');
        var swiper = swiperEl?.initSwiper || document.querySelector('.swiper-main')?.swiper;
        if (!swiper) return;

        var indexAttr = thumb.getAttribute('data-index');
        var targetIndex = indexAttr !== null ? parseInt(indexAttr, 10) : -1;
        if (isNaN(targetIndex) || targetIndex < 0) {
          var parent = thumb.parentElement;
          if (parent) {
            targetIndex = Array.from(parent.children).indexOf(thumb);
          }
        }

        if (targetIndex >= 0) {
          e.preventDefault();
          if (swiper.params?.loop) {
            swiper.slideToLoop(targetIndex, 400);
          } else {
            swiper.slideTo(targetIndex, 400);
          }
        }
      });
      window._vuuThumbListenerAttached = true;
    }

    // 3. Ensure Mobile Swipe Enabled
    var swiperEl = document.querySelector('media-gallery swiper-component');
    var swiper = swiperEl?.initSwiper || document.querySelector('.swiper-main')?.swiper;
    if (swiper) {
      swiper.allowTouchMove = true;
      if (swiper.params) {
        swiper.params.allowTouchMove = true;
        swiper.params.touchRatio = 1;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryEnhancements);
  } else {
    initGalleryEnhancements();
  }
  document.addEventListener('shopify:section:load', initGalleryEnhancements);
})();
